var toString = require('../internals/to-string');

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/normalize-string-argument.js